import React, {useMemo} from 'react'
import constants from 'helpers/constants';
import EntityProfileProvider from 'components/organisms/Providers/ProfileProvider/EntityProfileProvider';
import {useDealflowEntityGroups, useDealflowEntitySections} from 'services/entity/entity.utils';
import {useProviderView} from 'helpers/hooks/utils';
import {useAuthClientId} from 'components/organisms/Providers/AuthProvider/AuthProvider';
import {useClientGet} from 'services/client/client.hooks';
import {useViewList} from 'services/view/view.hooks';

const DealflowEntityProfileProvider = (props) => {
  const clientId = useAuthClientId();

  const client = useClientGet({clientId}, {enabled: clientId >= 0});

  const views = useViewList({
    relationType: 'collection',
    relationId: client?.data?.universeCollectionId,
    subscribed: true,
    allPages: true
  }, {
    enabled: client?.data?.universeCollectionId > 0
  });
  const view = useProviderView('dealflow.entity', views?.data, props.skipView);

  const groups = useDealflowEntityGroups(view);
  const sections = useDealflowEntitySections(view);

  // isLoading anything, is loading something definition related

  const isLoading = props?.isLoading || client.status?.isLoading || views.status?.isLoading;
  const isDefinitionsLoading = props?.isDefinitionsLoading;

  const cardDefinitions = useMemo(() => {
    return groups?.length > 0 ? groups : null;
  }, [groups]);

  const sectionDefinitions = useMemo(() => {
    return sections?.length > 0 ? sections : null;
  }, [sections]);

  const options = useMemo(() => ({
    cardState: {
      options: {
        name: 'dealflowEntity',
        type: constants.appState.type.local
      }
    },
    graphState: {
      options: {
        name: 'dealflowEntity',
        type: constants.appState.type.local
      }
    },
    assistantState: {
      options: {
        name: 'dealflowEntity',
        type: constants.appState.type.local
      }
    },
    cardDefinitions,
    sectionDefinitions
  }), [cardDefinitions, sectionDefinitions]);

  const fieldData = useMemo(() => {
    return {};
  }, []);

  const updaters = useMemo(() => {
    return {}
  }, []);

  return <EntityProfileProvider {...props}
                                options={options}
                                fieldData={fieldData}
                                updaters={updaters}
                                isDefinitionsLoading={isDefinitionsLoading}
                                isLoading={isLoading}>
    {props.children}
  </EntityProfileProvider>
};

DealflowEntityProfileProvider.propTypes = {
}

export default DealflowEntityProfileProvider;
